import * as React from 'react';
import { createElement } from 'react';
const Col = (props, ref) => {
    const { colSpan, children, ...others } = props;
    return (createElement("div", Object.assign({ ref: ref }, others, { className: `col col-${colSpan}` }), children));
};
const RefColComponent = React.forwardRef(Col);
RefColComponent.displayName = 'Col';
export default RefColComponent;
